import React from 'react';
import { translate } from 'react-i18next';
import PropTypes from 'prop-types';
import { Table } from 'semantic-ui-react';

const SnukTableCell = ({
  id, values, renderFn, t, tReady, ...rest
}) => (
  <Table.Cell key={id} {...rest}>
    { renderFn ? renderFn(values[id], values, t) : values[id] }
  </Table.Cell>
);

SnukTableCell.propTypes = {
  id: PropTypes.string.isRequired,
  values: PropTypes.shape({}).isRequired,
  renderFn: PropTypes.func,
  t: PropTypes.func.isRequired,
  tReady: PropTypes.bool.isRequired,
};

SnukTableCell.defaultProps = {
  renderFn: null,
};

export default translate()(SnukTableCell);



// WEBPACK FOOTER //
// ./src/components/reusable/SnukTable/SnukTableCell.js